import { Collapse, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ContentKey } from "../talentProfile/TalentDetails";
import { FormattedWorkHistory } from "./TalentWorkHistory";
import WorkHistoryActionButtons from "./WorkHistoryActionButtons";
import {
  getDateRange,
  getWorkLocationAndJobDescription,
} from "./workHistoryTableHelpers";
import { useContext } from "react";
import { AccessRightContext } from "../user/AccessRightProvider";

type Props = {
  row: FormattedWorkHistory;
  isOpen: boolean;
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  handleDelete: (id: string) => void;
  canEdit: boolean;
};

const WorkHistoryCollapsibleRows = ({
  row,
  isOpen,
  handleOpenEditModal,
  handleDelete,
  canEdit,
}: Props) => {
  const { t } = useTranslation("workHistory");
  const translatedJobDescriptionLabel = t("workHistory:jobDescription");
  const { canEditTalentProfile } = useContext(AccessRightContext);

  return (
    <TableRow>
      <TableCell style={{ padding: 0 }} colSpan={5}>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Table>
            <TableBody>
              {row.workLocations.map((workLocation, index) => {
                const isLastItem = index === row.workLocations.length - 1;
                return (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        width: "16px",
                        borderBottom: "none",
                      }}
                    />
                    <TableCell
                      width="50%"
                      size="small"
                      sx={{
                        padding: "0.5rem 0.5rem 0.5rem 0",
                        whiteSpace: "normal",
                        lineBreak: "anywhere",
                        borderBottom: isLastItem ? "none" : undefined,
                      }}
                    >
                      {getWorkLocationAndJobDescription(
                        workLocation,
                        translatedJobDescriptionLabel,
                      )}
                    </TableCell>
                    <TableCell
                      size="small"
                      sx={{
                        padding: "0.5rem",
                        textAlign: "center",
                        verticalAlign: "top",
                        borderBottom: isLastItem ? "none" : undefined,
                      }}
                    >
                      {getDateRange(
                        workLocation.startDate,
                        workLocation.endDate,
                      )}
                    </TableCell>
                    <TableCell
                      size="small"
                      width="25%"
                      sx={{
                        padding: 0,
                        verticalAlign: "top",
                        borderBottom: isLastItem ? "none" : undefined,
                      }}
                    >
                      {canEdit &&
                        canEditTalentProfile &&
                        (workLocation.editable ?? !workLocation.isEezyWork) && (
                          <WorkHistoryActionButtons
                            id={workLocation.workHistoryId}
                            handleOpenEditModal={handleOpenEditModal}
                            handleDelete={handleDelete}
                            canDelete={workLocation.deletable ?? false}
                          />
                        )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
};

export default WorkHistoryCollapsibleRows;
